import { render, staticRenderFns } from "./LayoutWithNav.vue?vue&type=template&id=7836519e&"
import script from "./LayoutWithNav.vue?vue&type=script&lang=js&"
export * from "./LayoutWithNav.vue?vue&type=script&lang=js&"
import style0 from "./LayoutWithNav.vue?vue&type=style&index=0&id=7836519e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports